import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { closeAllPanel, selectIsFormOpen } from 'features/common/formSlice';
import { accountsSlice } from 'app/store';
import {
    selectViewContentPanel,
    setViewContentPanel,
} from 'GeminiViewerComponent/features/contentPanel/contentPanelItemSlice';
const { selectActiveUser } = accountsSlice;

function PrivateRoute({ children }) {
    const activeUser = useSelector(selectActiveUser);
    let location = useLocation();
    const dispatch = useDispatch();
    const isFormOpen = useSelector(selectIsFormOpen);
    const isContentPanelOpen = useSelector(selectViewContentPanel);

    useEffect(() => {
        // TODO: This code needs to eventually be removed so we can
        // allow forms to stay open when changing paths. In order to support
        // this fully we need all forms to recognize when new form data is loaded
        // because the user has click on another item to edit. The forms should
        // prompt the user if they want to save changes before loading the new
        // content into the form.
        if (isFormOpen) {
            dispatch(closeAllPanel());
        }
        if (isContentPanelOpen) {
            dispatch(setViewContentPanel(false));
        }
    }, [location.pathname]);

    return activeUser ? children : <Navigate to="/account/login" state={{ from: location }} replace />;
}

export { PrivateRoute };
